import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { CommonTouchspin } from "../Common/CommonTouchspin";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlinedTouchspins } from "../../../../Constant";
import { DEFAULT_TOUCHSPIN_DATA, TOUCHSPIN_DATA } from "../../../../Data/FormWidgets";

const OutlinedTouchspin = () => {
  const initialValues = DEFAULT_TOUCHSPIN_DATA.map((data) => data.value);
  const [values, setValues] = useState(initialValues);
  
  const handleIncrement = (index:number) => {
    setValues((prevValues) => {
      return prevValues.map((value, i) => (i === index ? value + 1 : value));
    });
  };
  const handleDecrement = (index:number) => {
    setValues((prevValues) => {
      return prevValues.map((value, i) => (i === index && value > 0 ? value - 1 : value));
    });
  };
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={OutlinedTouchspins}  span={TOUCHSPIN_DATA} />
        <CardBody className="common-flex">
          {DEFAULT_TOUCHSPIN_DATA.map((data) => (
            <CommonTouchspin key={data.id} outline color={data.color} value={values[data.id - 1]} onIncrement={() => handleIncrement(data.id - 1)} 
                onDecrement={() => handleDecrement(data.id - 1)} btnClass={`spin-border-${data.color}`}/>
          ))}
        </CardBody>
      </Card>
    </Col>
  )
};

export default OutlinedTouchspin;
